import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import blogStyle from 'styles/css/BlogStyles.module.scss';
import { API_BLOG } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataPageBlog } from 'reduxx/actions/pages/blog';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';

const Blog = () => {

    const dispatch = useDispatch();

    const { token } = useSelector(state => state.login);
    const { categories, content, selectedCat, dataType } = useSelector(state => state.blog);
    // const filteredContent = selectedCat
    //     ? content.filter(item => item.catId === selectedCat)
    //     : content;
    const filteredContent = content
        .filter(item =>
            selectedCat ? item.catId === selectedCat : true
        )
        .filter(item => {
            if (dataType === 'media') return item.media !== null;
            if (dataType === 'text')  return item.media === null;
            return true; // all
        });

    useEffect(() => {
        if(content.length === 0)
            apiBlog();
    }, [Blog]);

    const apiBlog = () => {
        apiRequest({
            dispatch,
            endpoint: API_BLOG,
            method: 'post',
            data: {width: window.innerWidth},
            ...(token && { token }),
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataPageBlog('categories', res.categories));
                dispatch(handleChangeDataPageBlog('content', res.content));
            }
        });
    };



    const cat_swiper = {
        slidesPerView: 'auto',
        spaceBetween: 12,
        direction:'horizontal',
        // nested: true,
    };

    const sortByCat = (catId) => {
        const updatedCategories = categories.map(cat => ({
            ...cat,
            isSelect: cat.id === catId
        }));

        dispatch(handleChangeDataPageBlog('categories', updatedCategories));
        dispatch(handleChangeDataPageBlog('selectedCat', catId));
    };

    const setDetailsData = (contentId) => {
        // const contentItem = filteredContent.find(item => item.id === contentId);
        const index = content.findIndex(item => item.id === contentId);
        if(index !== -1)
            dispatch(handleChangeDataPageBlog('detailsIndex', index));
    };

    const setDataType = (type) => {
        dispatch(handleChangeDataPageBlog('dataType', type));
    };

    return (
        
        <div className={[sharedStyles.container, sharedStyles.bgwhite].join(' ')} style={{paddingBottom: '96px'}}>


            <section className={[sharedStyles.bgPrimary, sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.gapLg, sharedStyles.justifyEnd, sharedStyles.itemsCenter, sharedStyles.textWhite, sharedStyles['round-btm-2lg']].join(' ')} style={{minHeight: '230px', paddingBottom: '50px'}} >
                <span className={[sharedStyles.font3Lg, sharedStyles['font-weight-900']].join(' ')}>دکتر بیست</span>
                <span className={[sharedStyles.fontLg, sharedStyles['font-weight-600']].join(' ')}>مرجع تخصصی اطلاعات پزشکی</span>
            </section>




            <div className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.gapSm, sharedStyles['!mt-[24px]']].join(' ')} style={{paddingRight: '16px'}}>
                <span className={[sharedStyles.fontLg, sharedStyles['font-weight-600']].join(' ')}>دسته بندی مطالب</span>
                <div className={sharedStyles.flex}>
                    <Swiper {...cat_swiper}>
                    {
                        categories.map((cat, key) => (
                            <SwiperSlide key={`cat-${key}`} style={{width: 'auto'}}>
                                <div onClick={() => sortByCat(cat.id)} className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.itemsCenter, sharedStyles['w-fit'], sharedStyles['blog-cat'], sharedStyles['radius-round'], sharedStyles['px-lg'], sharedStyles['py-sm'], sharedStyles['cursor-pointer'], sharedStyles['cat-box'], cat.isSelect ? sharedStyles['item-active'] : ''].join(' ')}>
                                    <span className={sharedStyles['font-weight-600']}>{cat.title}</span>
                                    <span className={sharedStyles['font-weight-300']}>{cat.titleEn}</span>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                    </Swiper>
                    
                </div>
            </div>

            <div style={{height: '1px', backgroundColor: 'gray', marginTop: '16px', marginBottom: '16px'}} />

            <div className={[sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.itemsCenter, sharedStyles['px-lg']].join(' ')}>
                <span onClick={() => setDataType("all")} className={[sharedStyles['blog-cat'], sharedStyles['radius-round'], sharedStyles['px-2lg'], sharedStyles['py-sm'], sharedStyles['cursor-pointer'], sharedStyles['cat-box'], dataType === 'all' ? sharedStyles['item-active'] : ''].join(' ')}>همه</span>
                <span onClick={() => setDataType("media")} className={[sharedStyles['blog-cat'], sharedStyles['radius-round'], sharedStyles['px-2lg'], sharedStyles['py-sm'], sharedStyles['cursor-pointer'], sharedStyles['cat-box'], dataType === 'media' ? sharedStyles['item-active'] : ''].join(' ')}>فقط تصویری</span>
                <span onClick={() => setDataType("text")} className={[sharedStyles['blog-cat'], sharedStyles['radius-round'], sharedStyles['px-2lg'], sharedStyles['py-sm'], sharedStyles['cursor-pointer'], sharedStyles['cat-box'], dataType === 'text' ? sharedStyles['item-active'] : ''].join(' ')}>فقط متنی</span>
            </div>


            {
                filteredContent.map((item, key) => (
                    <div className={[sharedStyles.flex, sharedStyles['flex-col'], blogStyle['item-blog']].join(' ')}>
                        <img src={item.thumbnail} alt={item.title} style={{aspectRatio: '1/1'}} />
                        <h2 className={[sharedStyles['px-lg']].join(' ')} style={{marginBottom: '0'}}>{item.title}</h2>
                        <p className={[sharedStyles['px-lg'], sharedStyles['line-clamp-3'], sharedStyles.textJustify].join(' ')} style={{marginBottom: '0'}}>{item.text}</p>
                        <Link to={`/blog/${item.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} onClick={() => setDetailsData(item.id)} className={[sharedStyles['w-fit'], sharedStyles['mx-lg'], sharedStyles['mt-[16px]'], sharedStyles['radius-round'], sharedStyles['px-lg'], sharedStyles['py-sm'], sharedStyles['text-primary'], sharedStyles['decoration-none']].join(' ')} style={{backgroundColor: '#d9d9d9', border: 'none'}}>
                            ادامه مطلب
                        </Link>
                    </div>
                ))
            }
                    



            
        </div>

    );
}

export default Blog;